import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const LockoutCountdown = ({ durationSeconds = 1800, onComplete }) => {
  const [remaining, setRemaining] = useState(durationSeconds);

  useEffect(() => {
    setRemaining(durationSeconds);
  }, [durationSeconds]);

  useEffect(() => {
    if (remaining <= 0) {
      onComplete?.();
      return;
    }
    const timer = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [remaining, onComplete]);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const progress = ((durationSeconds - remaining) / durationSeconds) * 100;

  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
        py: 3,
        px: 2,
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 48, color: "#d32f2f", mb: 1 }} />

      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "#d32f2f", mb: 0.5 }}
      >
        Account Temporarily Locked
      </Typography>

      <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
        Too many failed attempts. Please wait before trying again.
      </Typography>

      {/* Timer circular */}
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: 100,
          height: 100,
          borderRadius: "50%",
          border: "3px solid #eee",
          background: `conic-gradient(#d32f2f ${progress}%, #eee ${progress}%)`,
          position: "relative",
          mb: 1,
        }}
      >
        <Box
          sx={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            bgcolor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, color: "#d32f2f", lineHeight: 1 }}>
            {minutes}:{seconds.toString().padStart(2, "0")}
          </Typography>
          <Typography variant="caption" sx={{ color: "#999" }}>
            remaining
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LockoutCountdown;
